import React from 'react';

import { PdfUrlValue } from './types';

const PdfUrlContext = React.createContext<PdfUrlValue>({
  pdfBlob: null,
  pdfUrl: null,
  setPdfBlob: null,
  setPdfUrl: null,
});

export default PdfUrlContext;
